(function () {

  /* =========================================================
     VIEW TOGGLE — grid layout buttons
     ========================================================= */

  function initDcgCollectionToolbar(scope) {
    var root = (scope || document).querySelector('#main-collection-filters');
    if (!root) return;

    var viewButtons = root.querySelectorAll('.collectiongrid-layout');
    viewButtons.forEach(function (button) {
      if (!button.hasAttribute('tabindex')) button.setAttribute('tabindex', '0');
      button.setAttribute('role', 'button');
      if (button.dataset.dcgToolbarBound === 'true') return;
      button.dataset.dcgToolbarBound = 'true';
      button.addEventListener('click', function () { setActiveView(button, root); });
      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); button.click(); }
      });
    });

    syncInitialActiveView(root);
  }

  function setActiveView(activeButton, root) {
    if (!root) return;
    root.querySelectorAll('.collectiongrid-layout').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    activeButton.classList.add('is-active');
    activeButton.setAttribute('aria-pressed', 'true');
  }

  function syncInitialActiveView(root) {
    if (!root) return;
    var activeButton =
      root.querySelector('.collectiongrid-layout.grid-layout-default') ||
      root.querySelector('.collectiongrid-layout.is-active') ||
      root.querySelector('.collectiongrid-layout.column-3');
    if (activeButton) setActiveView(activeButton, root);
  }

  /* =========================================================
     MOBILE FILTER BACK BUTTON
     Removes 'menu-opening' to trigger CSS slide-out, then
     closes the <details> after the transition completes.
     ========================================================= */

  function initMobileFilterBack() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mobile-facets__close-button');
      if (!btn) return;
      e.preventDefault();
      var details = btn.closest('details');
      if (!details) return;
      details.classList.remove('menu-opening');
      setTimeout(function () { details.removeAttribute('open'); }, 420);
    });
  }

  /* =========================================================
     INJECT BINDER FILTERS INTO MOBILE SORT & FILTER DRAWER
     On mobile (<992px), the sidebar is hidden via CSS.
     We clone #SortTags from the sidebar into the mobile
     facets drawer so users get all filters in one place.
     Called both on load and whenever BinderPOS reinitialises.
     ========================================================= */

  /* Retry ceiling — DCG 03 AUG 2026.
     This function used to re-schedule itself every 400ms with no attempt
     counter, unlike every other retry loop in the theme (dcg-cart-addons.js:23
     caps at 60, dcg-advanced-search.js caps at 100 and 120).

     #SortTags is only rendered by sidebar.liquid:164, and only for recognised
     TCG singles collections. The early-return guard above it — .mobile-facets__main
     from collection-filters-form.liquid:71 — exists on every collection. So on
     any NON-singles collection viewed below 992px the element never appeared
     and this fired every 400ms for the life of the page: a 2.5Hz wake-up loop
     running the entire session, draining battery for nothing.

     30 x 400ms = a 12s ceiling, which is generous for BinderPOS to populate. */
  var MOBILE_FILTER_MAX_ATTEMPTS = 30;

  function injectBinderFiltersIntoMobileDrawer(attempt) {
    attempt = attempt || 0;
    if (window.innerWidth >= 992) return;

    var mobileMain = document.querySelector('.mobile-facets__main');
    if (!mobileMain) return;

    // Remove any previous injection
    var prev = mobileMain.querySelector('.dcg-binder-mobile');
    if (prev) prev.remove();

    // Wait for BinderPOS to have populated #SortTags
    var sortTags = document.getElementById('SortTags');
    if (!sortTags || sortTags.innerHTML.trim() === '') {
      // Retry after BinderPOS populates, up to the ceiling above.
      if (attempt < MOBILE_FILTER_MAX_ATTEMPTS) {
        setTimeout(function () {
          injectBinderFiltersIntoMobileDrawer(attempt + 1);
        }, 400);
      }
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'dcg-binder-mobile';

    var heading = document.createElement('div');
    heading.className = 'dcg-binder-mobile__heading';
    heading.textContent = 'Filters';
    wrapper.appendChild(heading);

    var clone = sortTags.cloneNode(true);
    clone.id = 'SortTagsMobile';
    // Remove script tags from clone — they already ran
    clone.querySelectorAll('script').forEach(function (s) { s.remove(); });
    wrapper.appendChild(clone);

    // Insert at the top of the mobile facets main area
    mobileMain.insertBefore(wrapper, mobileMain.firstChild);

    // Mirror clicks on cloned links back to the real sidebar links
    // so BinderPOS's own click handlers trigger correctly
    clone.querySelectorAll('a').forEach(function (cloneLink) {
      cloneLink.addEventListener('click', function (e) {
        e.preventDefault();
        var href = cloneLink.getAttribute('href');
        var tagName = cloneLink.getAttribute('data-tagname');
        // Find matching real link and click it
        var realLink = tagName
          ? sortTags.querySelector('[data-tagname="' + tagName + '"]')
          : sortTags.querySelector('a[href="' + href + '"]');
        if (realLink) {
          realLink.click();
        } else if (href && href !== '#') {
          window.location.href = href;
        }
      });
    });
  }

  /* =========================================================
     ACTIVE FILTER PILLS — show on mobile below Sort button
     ========================================================= */

  function syncActivePills() {
    var desktopPills = document.querySelector('.active-facets-desktop');
    var mobileBtn = document.querySelector('.dcg-collection-toolbar__mobile');
    if (!desktopPills || !mobileBtn) return;

    var existing = mobileBtn.querySelector('.dcg-active-pills-mobile');
    if (existing) existing.remove();

    var hasActive = desktopPills.querySelectorAll('.active-facets__button').length > 0;
    if (!hasActive) return;

    var clone = desktopPills.cloneNode(true);
    clone.className = 'dcg-active-pills-mobile active-facets active-facets-desktop';
    clone.style.display = 'flex';
    mobileBtn.appendChild(clone);
  }

  /* =========================================================
     VIEW MORE — AJAX append
     ========================================================= */

  var viewMoreUsed = false;

  function initViewMore() {
    var btn = document.querySelector('.dcg-view-more-btn');
    if (!btn) return;
    if (btn.dataset.vmBound) return;
    btn.dataset.vmBound = 'true';

    btn.addEventListener('click', function () {
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newItems = doc.querySelectorAll('#main-collection-product-grid > li');
          var grid = document.getElementById('main-collection-product-grid');
          newItems.forEach(function (li) { grid.appendChild(li.cloneNode(true)); });

          document.dispatchEvent(new CustomEvent('dcg:collection:rendered'));

          // Hide pagination the first time we append
          if (!viewMoreUsed) {
            viewMoreUsed = true;
            var pagination = document.querySelector('.dcg-collection__pagination .pagination-view nav');
            if (pagination) pagination.classList.add('dcg-pagination-hidden');
          }

          var nextBtn = doc.querySelector('.dcg-view-more-btn');
          if (nextBtn) {
            btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
            btn.classList.remove('is-loading');
            btn.disabled = false;
          } else {
            var wrap = btn.closest('.dcg-view-more-wrap');
            if (wrap) wrap.remove();
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  }

  /* =========================================================
     Boot
     ========================================================= */

  window.initDcgCollectionToolbar = initDcgCollectionToolbar;

  document.addEventListener('DOMContentLoaded', function () {
    initDcgCollectionToolbar(document);
    initMobileFilterBack();
    initViewMore();
    syncActivePills();
    // Inject after a short delay so BinderPOS has time to populate #SortTags
    setTimeout(injectBinderFiltersIntoMobileDrawer, 600);
  });

  document.addEventListener('dcg:collection:rendered', function () {
    initDcgCollectionToolbar(document);
  });

  // Re-inject if window resizes across the 992px breakpoint
  var wasNarrow = window.innerWidth < 992;
  window.addEventListener('resize', function () {
    var isNarrow = window.innerWidth < 992;
    if (isNarrow && !wasNarrow) {
      setTimeout(injectBinderFiltersIntoMobileDrawer, 200);
    }
    wasNarrow = isNarrow;
  });

})();
